import React from "react";
import _ from "lodash";

import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid/Grid";

import PercentageInputField from "./PercentageInput";
import {withPercentOrDash} from "../../../../../../../../../../utils/utils";
import WarningTooltip from "../../../../../../../../../../components/WarningTooltip";

const getFee = (item, options) => options.costsConfig[item.uid] || 0;

export const useInputStyles = makeStyles(() => ({
  inputRoot: {
    margin: 0,
    height: 35,
    fontSize: 14
  },
  labelRoot: {
    margin: 0
  }
}))

const Error = ({error}) => <b style={{color: 'red', marginLeft: 'auto'}}>{error}</b>

const ONGOING_COST_INFO = "Dem Kostensatz liegen Annahmen über eine durchschnittliche Aufteilung auf aktive Fonds " +
  "verschiedener Fondskategorien in der jeweiligen der Risikoklasse zugrunde.";

const getOngoingCost = (item, options) => _.round((getFee(item, options) * item.answer / 100) || 0, 2)

export const tableOngoingCostsStructure = [
  {
    header: [() => 'Laufende Kostenart'],
    body: [({item}) => item.question_text],
    footer: [({options}) => <Grid container><b>Gesamt</b><Error error={options.costError} /></Grid>],
    colSpan: {footer: 2}
  },
  {
    header: [() => <>ø Produktkosten<WarningTooltip title={ONGOING_COST_INFO} width={600}/></>],
    body: [({item, options}) => withPercentOrDash(getFee(item, options), false)],
    align: 'right',
    cellClassName: 'percentage'
  },
  {
    header: [() => 'Gewichtung'],
    body: [({item, options}) => (
      <PercentageInputField
        onChange={(val) => options.onChange(item, val)}
        value={item.answer}
        maxValue={_.get(options.maxValues, item.uid)}
        dataId={item.uid}
      />
    )],
    footer: [({items}) => <b>{withPercentOrDash(_.sumBy(items, 'answer') || 0, false)}</b>],
    align: 'right',
    cellClassName: 'percentage'
  },
  {
    header: [() => 'Kosten (%)'],
    body: [({item, options}) => withPercentOrDash(getOngoingCost(item, options), false)],
    footer: [({items, options}) => <b>{withPercentOrDash(_.sumBy(items, item => getOngoingCost(item, options)), false)}</b>],
    align: 'right',
    cellClassName: 'percentage'
  },
]